// extracted by mini-css-extract-plugin
export default {"badgeList":"Badge_badgeList__wyeM-","badge":"Badge_badge__FbGwu","warning":"Badge_warning__FLK3z","danger":"Badge_danger__o3vK9"};